function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (f) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;

    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }

    g.BugsnagPluginVue = f();
  }
})(function () {
  var define, module, exports;
  var _$src_1 = {};

  var _this = this;

  _$src_1 = /*#__PURE__*/function () {
    function BugsnagPluginVue() {
      // Fetch Vue from the window object, if it exists
      var globalVue = typeof window !== 'undefined' && window.Vue;
      this.name = 'vue';
      this.lazy = arguments.length === 0 && !globalVue;

      if (!this.lazy) {
        this.Vue = (arguments.length <= 0 ? undefined : arguments[0]) || globalVue;
        if (!this.Vue) throw new Error('@bugsnag/plugin-vue reference to `Vue` was undefined');
      }
    }

    var _proto = BugsnagPluginVue.prototype;

    _proto.load = function load(client) {
      if (this.Vue) {
        install(this.Vue, client);
        return {
          installVueErrorHandler: function installVueErrorHandler() {
            return client._logger.warn('installVueErrorHandler() was called unnecessarily');
          }
        };
      }

      return {
        installVueErrorHandler: function installVueErrorHandler(Vue) {
          if (!Vue) client._logger.error(new Error('@bugsnag/plugin-vue reference to `Vue` was undefined'));
          install(Vue, client);
        }
      };
    };

    return BugsnagPluginVue;
  }();

  var install = function install(Vue, client) {
    var prev = Vue.config.errorHandler;

    var handler = function handler(err, vm, info) {
      var handledState = {
        severity: 'error',
        unhandled: true,
        severityReason: {
          type: 'unhandledException'
        }
      };
      var event = client.Event.create(err, true, handledState, 1);
      event.addMetadata('vue', {
        errorInfo: info,
        component: vm ? formatComponentName(vm, true) : undefined,
        props: vm ? vm.$options.propsData : undefined
      });

      client._notify(event);

      if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(err);
      if (typeof prev === 'function') prev.call(_this, err, vm, info);
    };

    Vue.config.errorHandler = handler;
  }; // taken and reworked from Vue.js source


  var formatComponentName = function formatComponentName(vm, includeFile) {
    if (vm.$root === vm) return '<Root>';
    var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;

    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (name ? '<' + classify(name) + '>' : '<Anonymous>') + (file && includeFile !== false ? ' at ' + file : '');
  }; // taken and reworked from Vue.js source


  var classify = _$src_1.classify = function (str) {
    return str.replace(/(?:^|[-_])(\w)/g, function (c) {
      return c.toUpperCase();
    }).replace(/[-_]/g, '');
  };

  return _$src_1;
});